module.exports = __webpack_public_path__ + "static/010_001-558abea617264e27c243decd36ab38be.jpg";